let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5MoOU")).then(() => parcelRequire('5HjYw'));